export enum Central {
  REDES = 'REDES',
  DEFAULT = 'DEFAULT',
}

export interface CentralConfig {
  retrieveQueryUrl: string;
  retrieveColQuery: string;
  retrieveFieldQuery: string;
}

const CENTRAL_CONFIGS: Record<Central, CentralConfig> = {
  [Central.REDES]: {
    retrieveQueryUrl:
      '?$select=itau_interacaoid&$expand=rede_atendimento_interacaoid_itau_interacao($select=rede_atendimentoid)',
    retrieveColQuery: 'rede_atendimento_interacaoid_itau_interacao',
    retrieveFieldQuery: 'rede_atendimentoid',
  },
  [Central.DEFAULT]: {
    retrieveQueryUrl:
      '?$select=itau_interacaoid&$expand=itau_incident_InteracaoId_itau_interacao($select=incidentid)',
    retrieveColQuery: 'itau_incident_InteracaoId_itau_interacao',
    retrieveFieldQuery: 'incidentid',
  },
} as const;

export class CentralRetrieveConfigFactory {
  static getConfig(central: Central): CentralConfig {
    const config = CENTRAL_CONFIGS[central];
    if (!config) {
      throw new Error(`Configuração não encontrada para a central: ${central}`);
    }
    return config;
  }
}
